import { useCallback } from 'react'
import { useToast } from './useToast'

export function useBinanceCheck() {
  const { showError } = useToast()

  const checkBinanceAndExecute = useCallback((callback: () => void) => {
    const isBinanceApp = !!(window.isBinance && window.binancew3w)
    console.log('isBinanceApp', isBinanceApp)
    
    // if (!isBinanceApp) {
    //     console.log('showError')
    //     showError("Please use your Binance keyless wallet to participate in the campaign.")
    //     return
    // }
    
    callback()
  }, [showError])

  const isBinanceApp = !!(window.isBinance && window.binancew3w)

  return {
    checkBinanceAndExecute,
    isBinanceApp
  }
} 